/* eslint-disable max-len */
import 'react';

const ImportErrorSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => {
    const date = Date.now();
    const id = `export-error-1-${date}`;
    const id2 = `export-error-2-${date}`;

    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
            <defs>
                <filter
                    x="-275%"
                    y="-175%"
                    width="650%"
                    height="650%"
                    filterUnits="objectBoundingBox"
                    id={id}
                >
                    <feOffset
                        dy={2}
                        in="SourceAlpha"
                        result="shadowOffsetOuter1"
                    />
                    <feGaussianBlur
                        stdDeviation={1.5}
                        in="shadowOffsetOuter1"
                        result="shadowBlurOuter1"
                    />
                    <feColorMatrix
                        values="0 0 0 0 1 0 0 0 0 0.22538355 0 0 0 0 0.190952271 0 0 0 0.2 0"
                        in="shadowBlurOuter1"
                    />
                </filter>
                <path d="M10 16a1 1 0 100-2 1 1 0 000 2z" id={id2} />
            </defs>
            <g fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <g transform="translate(2 2)">
                    <circle
                        stroke="#FF7272"
                        strokeWidth={1.5}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        cx={10}
                        cy={10}
                        r={10}
                    />
                    <path
                        stroke="#FF7272"
                        strokeWidth={1.5}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M10 12V5"
                    />
                    <use
                        fill="#000"
                        filter={`url(#${id})`}
                        xlinkHref={`#${id2}`}
                    />
                    <use fill="#FF7272" xlinkHref={`#${id2}`} />
                </g>
            </g>
        </svg>
    );
};

export default ImportErrorSvg;
